import React, { useMemo } from 'react';
import { Container } from 'semantic-ui-react';
import ListingBlockReversible from './ListingBlockReversible';
import { toSnakeCase } from '../helpers/common';
import { useEffect } from 'react';
import { useState } from 'react';

const ImageAndContentRL = (props) => {
  const { module } = props;
  const { anchorTagLinkText, direction, columns, sectionTitle, backgroundColor } = module;
  const { columnContent, columnImage } = columns;
  const { video, image, retinaImage, contentType } = columnImage;
  const hasImage = image?.localFile?.childImageSharp?.gatsbyImageData ? true : false;
  const hasVideo = video && video.youtubeId ? true : false;
  const hasMedia = hasImage || hasVideo;
  const rtl = hasMedia && direction === 'image_right' ? true : false;
  // added retina logic.. dont know if this will work
  const [devicePixelRatio, setDevicePixelRatio] = useState(1);
  const imgFluid =
    hasMedia && devicePixelRatio <= 1
      ? columnImage.image && columnImage.image.localFile.childImageSharp.gatsbyImageData
      : hasMedia && retinaImage && devicePixelRatio > 1
        ? retinaImage && retinaImage.localFile.childImageSharp.gatsbyImageData
        : columnImage.image?.localFile?.childImageSharp?.gatsbyImageData;
  const imgAlt = hasMedia ? columnImage?.image?.altText : '';
  const hasThumbnail = video?.thumbnail?.localFile?.childImageSharp?.gatsbyImageData ? true : false;
  const title = columnContent.title;
  const excerpt = columnContent.excerpt;
  const linkType = columnContent?.linkType;
  const buttonLink = columnContent?.buttonLink?.link;
  const buttonText = columnContent?.buttonLink?.title;
  const externalLink = columnContent?.externalLink?.link;
  const externalLinkText = columnContent?.externalLink?.title;
  const textLinks = columnContent.textLinks;
  const altHeading = columnContent.altHeading;
  let formattedTextLinks = [];
  if (textLinks) {
    formattedTextLinks = textLinks.map((textLink) => {
      return {
        link: textLink.link?.url,
        title: textLink.title,
        target: textLink.link?.target,
      };
    });
  }

  useEffect(() => {
    if (window) {
      setDevicePixelRatio(window.devicePixelRatio);
    }
  }, []);
  
  return (
    <section className={`image-and-content-rl ${backgroundColor && backgroundColor !== 'none' ? `${backgroundColor}-bg` : ''}`} id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        {sectionTitle ? (
          <div className="grid-wrapper">
            <h2 className="heading-one image-and-content-rl-intro-title">{sectionTitle}</h2>
          </div>
        ) : null}
        <div className="grid-wrapper image-and-content-rl-content-grid">
          <ListingBlockReversible
            has_image={hasImage}
            rtl={rtl}
            img_fluid={useMemo(() => ({ ...imgFluid, aspectRatio: 16 / 9 }), [imgFluid])}
            img_retina={useMemo(() => ({ ...retinaImage, aspectRatio: 16 / 9 }), [retinaImage])}
            img_alt={imgAlt}
            title={title}
            excerpt={excerpt && excerpt}
            link_type={linkType}
            button_link={linkType === 'external' ? externalLink : buttonLink}
            button_text={linkType === 'external' ? externalLinkText : buttonText}
            external_link={externalLink}
            external_link_text={externalLinkText}
            text_links={formattedTextLinks}
            has_video={hasVideo}
            content_type={contentType}
            youtube_id={video && video.youtubeId}
            has_thumbnail={hasThumbnail}
            thumbnail={video?.thumbnail}
            alt_heading={altHeading}
          />
        </div>
      </Container>
    </section>
  );
};

export default ImageAndContentRL;
